import React, { useState, useRef, useEffect, useContext } from 'react';
import {useNavigate, useLocation } from 'react-router-dom'
import { Button } from 'primereact/button';
import { Toast } from 'primereact/toast';
import {NotificationContext} from '../../Context/NotificationContext'
import styles from './NotificationToast.module.css'

export const NotificationToast = () => {

    const {unreadCount} = useContext(NotificationContext);

    const [visible, setVisible] = useState(false);
    const toastBC = useRef(null);

    const location = useLocation();
    const navigate = useNavigate();

    const showConfirmToast = () => {
        if(unreadCount){
            confirm(unreadCount);
        }
    }
    const go = () => {
        navigate('/notifications')
        toastBC.current.clear();
        setVisible(false);
    }

    const confirm = (count) => {
        if (!visible && !(location.pathname.includes('notifications'))) {
            setVisible(true);
            toastBC.current.clear();
            toastBC.current.show({
                severity: 'info',
                summary: `У вас є нові повідомлення (${count}). Бажаєте прочитати?`,
                sticky: true,
                content: (props) => (

                    <div className="flex flex-column align-items-left" style={{ flex: '1' }}>
                        <div className="flex align-items-center gap-2">
                            <span className="font-bold text-900">Система</span>
                        </div>
                        <div className="font-medium my-1 text-900">{props.message.summary}</div>
                        <div style={{display:'flex', justifyContent:'flex-end'}}>
                            <Button className={`p-button-sm ${styles.button}`} label="Перейти" severity="info"  onClick={go} icon="pi pi-envelope"></Button>
                        </div>
                    </div>
                )
            });
        }
    };

    useEffect(() => {
        showConfirmToast()
    },[unreadCount])

    return(
        <Toast ref={toastBC} position="bottom-center" />
    )
}